import type { IconNames } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';

import QueueFromPayload from 'components/powerFlowShared/components/queueFromPayload';
import {
  FlowNodeTypes,
  OptionT,
} from 'components/powerFlowShared/components/types';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
} from 'fable/flowEditor';

import { PowerCallFlowExtraDataT } from '../PowerCallFlow';
import AnnounceFromPayload from '../helpers/announceFromPayload';
import { VoicemailModal as ActionModal } from '../modals/voicemail';
import type { AnnouncementPayloadT } from '../types';

type Payload = {
  announcement: AnnouncementPayloadT;
  queue: null | OptionT;
  transcription: boolean;
};

export type FlowCallNodeVoicemail = NodeT<FlowNodeTypes.VOICEMAIL, Payload>;

export class VoicemailNode extends NodeTypeComponent<
  FlowCallNodeVoicemail,
  PowerCallFlowExtraDataT
>() {
  static icon: IconNames = 'conversations';
  static label = 'Voicemail';
  static helpText =
    'Record or upload a voicemail asking your customers to leave a message if no agents are available.';
  static color = flowNodeColor.green;
  static ActionModal = ActionModal;
  static actionTrigger = { type: FlowNodeTypes.VOICEMAIL };
  static updateConnection = (
    node: FlowCallNodeVoicemail,
    _port: InternalPortT,
    newConnection: string,
  ): FlowCallNodeVoicemail => {
    const payload = { ...node.payload };
    if (payload?.queue) {
      payload.queue.value = newConnection;
    }

    return { ...node, payload };
  };

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    return (
      <FlowNode
        color={VoicemailNode.color}
        icon={VoicemailNode.icon}
        label={VoicemailNode.label}
        text={
          <div>
            <AnnounceFromPayload
              node={this.props.node}
              extraData={this.props.extraData}
            />
            <QueueFromPayload node={this.props.node} />
          </div>
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
